<template>
	<TypographyTitle :level="2">{{ $t('rover-page.header') }}</TypographyTitle>
	<RoverNetworkSettings />
	<RoverForm :roverId="roverId" />
	<RoverPasswordForm :roverId="roverId" />
</template>

<script>
import { computed } from 'vue';

import { TypographyTitle } from 'ant-design-vue';

import { useRoute } from 'vue-router';

import RoverNetworkSettings from '@/components/rovers/RoverNetworkSettings';
import RoverForm from '@/components/rovers/RoverForm';
import RoverPasswordForm from '@/components/rovers/RoverPasswordForm';

export default {
	components: {
		TypographyTitle, RoverNetworkSettings, RoverForm, RoverPasswordForm,
	},
	setup() {
		const route = useRoute();
		const roverId = computed(() => route.params.roverId);
		return {
			roverId,
		};
	}
}
</script>
